import { useState, useCallback } from 'react';
import { Field } from '@ontruck/orc';
import moment from 'moment';

import { formatIncompleteHour, checkIfRealHour } from './utils';

const TimeField = ({ value, onChange, label, hasError, nameKey = 'from' }) => {
  const timeMoment = moment(value);
  const [formattedTime, setFormattedTime] = useState(timeMoment.format('HH:mm'));

  const handleChange = useCallback((_, { value: newFormattedValue }) => {
    setFormattedTime(newFormattedValue);
  }, []);

  const handleBlur = useCallback(() => {
    const formattedHour = formatIncompleteHour(formattedTime);

    if (checkIfRealHour(formattedHour)) {
      setFormattedTime(formattedHour);
      const [hour, minute] = formattedHour.split(':');
      onChange({ hour, minute });
      return;
    }

    setFormattedTime('');
  }, [formattedTime, onChange]);

  return (
    <Field
      label={label}
      fullWidth
      value={formattedTime}
      onChange={handleChange}
      onBlur={handleBlur}
      width="S"
      maskedProps={{ mask: '99:99', maskChar: null }}
      invalid={hasError}
      name={`TimeField-${nameKey}`}
      id={`TimeField-${nameKey}`}
    />
  );
};

export default TimeField;
